import { render, staticRenderFns } from "./JsFooter.vue?vue&type=template&id=70cf3724"
import script from "./JsFooter.vue?vue&type=script&lang=js"
export * from "./JsFooter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports